import { GlobalContext } from "../GlobalContext";
import { DeferredStateful, PromiseUtils } from "../Promises/PromiseUtils";

export class TimerUtils {
    private static _waiterList: Map<any, number> = new Map<any, number>();
    private static _waiterListPrms: Map<any, DeferredStateful<void>> = new Map<any, DeferredStateful<void>>();
    private static _waiterIdList: Map<any, Map<any, number>> = new Map<any, Map<string, number>>();
    private static _intervalList: Map<any, { maxIter: number; curIter: number; intervaId: number }> = new Map<any, { maxIter: number; curIter: number; intervaId: number }>();
    //private static _intervalIdList: Map<any, Map<any, number>> = new Map<any, Map<string, number>>();

    public static waitOrCancelPromise(id: any): Promise<void> {
        if (TimerUtils._waiterList.has(id) && TimerUtils._waiterListPrms.has(id)) return TimerUtils._waiterListPrms.get(id)!.promise;
        return Promise.resolve();
    }
    public static waitOrCancel(id: any, action: () => void, miliseconds: number = 0): Promise<void> {
        let prom = PromiseUtils.deferStateful<void>();

        if (TimerUtils._waiterList.has(id)) {
            clearTimeout(TimerUtils._waiterList.get(id) as number);
            TimerUtils._waiterList.delete(id);
        }
        if (!TimerUtils._waiterListPrms.has(id)) {
            TimerUtils._waiterListPrms.set(id, prom);
        } else {
            prom = TimerUtils._waiterListPrms.get(id) as DeferredStateful<void>;
        }

        const item = self.setTimeout(() => {
            action();
            TimerUtils._waiterList.delete(id);
            TimerUtils._waiterListPrms.delete(id);
            prom.resolve();
        }, miliseconds);
        TimerUtils._waiterList.set(id, item);

        return prom.promise;
    }

    public static waitOrCancelInstance(instance: any, id: string, action: () => void, miliseconds: number = 0): void {
        let inst = TimerUtils._waiterIdList.get(instance);
        if (inst != undefined) {
            this._deleteWaiterIdListItemAndClearTimeout(instance, id);
        } else {
            TimerUtils._waiterIdList.set(instance, new Map<string, number>());
            inst = TimerUtils._waiterIdList.get(instance);
        }
        const item = self.setTimeout(() => {
            action();
            this._deleteWaiterIdListItemAndClearTimeout(instance, id);
        }, miliseconds);
        (inst as any).set(id, item);
    }

    private static _deleteWaiterIdListItemAndClearTimeout(instance: any, id: string): void {
        const inst = TimerUtils._waiterIdList.get(instance);
        if (inst != undefined) {
            if (inst.has(id)) {
                clearTimeout(inst.get(id) as number);
                inst.delete(id);
            }
            if (inst.size == 0)
                TimerUtils._waiterIdList.delete(instance);
            TimerUtils._waiterListPrms.delete(id);
        }
    }

    /**
     * Nastavi interval, ktery bude probihat tak dlouho dokud funkce nevrati false a nebo nedosahne maximalniho poctu iteraci, ktery byl nastaven.
     * Pokud je tato metoda volana nekolikrat za sebou se stejnym ID, vzdy se provede smazani stare a inicializace nove.
     *
     * @param id identifikator
     * @param action Spustena metoda
     * @param miliseconds Jak casto se bude opakovat
     * @param maxIter Maximalni pocet opakovani
     */
    public static intervalOrCancel(id: any, action: () => boolean, miliseconds: number = 0, maxIter: number = 0): void {
        if (TimerUtils._intervalList.has(id)) {
            const intervalData = TimerUtils._intervalList.get(id);
            clearInterval((intervalData as any).intervaId as number);
            TimerUtils._intervalList.delete(id);
        }

        const item = self.setInterval(() => {
            const intervalData = TimerUtils._intervalList.get(id);
            if (intervalData == undefined)
                throw Error("Object is undefined");

            if (action()) {
                clearInterval(intervalData.intervaId as number);
                TimerUtils._intervalList.delete(id);
                return;
            }

            if (intervalData.maxIter > 0) {
                if (intervalData.curIter == 0) {
                    clearInterval(intervalData.intervaId as number);
                    TimerUtils._intervalList.delete(id);
                } else {
                    intervalData.curIter--;
                }
            }
        }, miliseconds);

        TimerUtils._intervalList.set(id, {
            intervaId: item,
            maxIter: maxIter,
            curIter: maxIter,
        });
    }
}

GlobalContext.registerType(TimerUtils);
